
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as echarts from "echarts";

type EChartsOption = echarts.EChartsOption;

@Component({ components: {} })
export default class RingGraph extends Vue {
  @Prop({ type: Number, default: 0 }) proportion!: number;
  @Prop({ type: Number, default: 0 }) id!: number;
  private graphInstance!: echarts.ECharts;
  integer = 0;
  decimals = "";

  // 配置项
  getOptions(): EChartsOption {
    return {
      series: [
        {
          type: "pie",
          radius: ["85%", "95%"],
          emptyCircleStyle: {
            color: "#EBEDFF"
          }
        },
        {
          type: "pie",
          radius: ["80%", "100%"],
          hoverAnimation: false,
          labelLine: {
            show: false
          },
          data: [
            {
              value: 0,
              itemStyle: {
                color: "#5F45F2",
                borderColor: "#fff",
                borderWidth: 1
              }
            },
            {
              value: 0,
              itemStyle: {
                color: "transparent"
              }
            }
          ]
        }
      ]
    } as EChartsOption;
  }

  get notShowFractionalPart() {
    return [0, 100].includes(this.proportion);
  }

  // 图
  @Watch("proportion", { immediate: true })
  ringGraph() {
    if (this.graphInstance) {
      this.graphInstance.dispose();
    }
    this.$nextTick(() => {
      const option = this.getOptions();
      if (option.series) {
        if (this.notShowFractionalPart) {
          this.integer = this.proportion;
        } else {
          const numList = this.proportion.toFixed(2).split(".");
          this.integer = +numList[0];
          this.decimals = numList[1];
        }
        if (this.proportion === 0) {
          option.series = [option.series[0]];
        } else if (this.proportion <= 100 && this.proportion > 0) {
          option.series[1].data[0].value = this.proportion;
          option.series[1].data[1].value = 100 - this.proportion;
        }
      }
      const chartDom = document.getElementById(
        `ringGraph${this.id}`
      ) as HTMLElement;
      this.graphInstance = echarts.init(chartDom, undefined, {
        renderer: "svg"
      });
      this.graphInstance.setOption(option);
    });
  }
}
